module.exports = require("jsdom-global/register");


//////////////////
// WEBPACK FOOTER
// external "jsdom-global/register"
// module id = 3
// module chunks = 0